import axios from "axios";

import { API_URL } from "app/constants/variables";

const request = axios.create({
  baseURL: API_URL,
});

export default request;
